import { ConnectionState } from '../types';
import type { ThemeTokens } from '../lib/theme';

export interface StateDisplay {
  icon: string;
  color: string;
}

const STATE_ICONS: Record<ConnectionState, string> = {
  [ConnectionState.Connected]: '✓',
  [ConnectionState.Connecting]: '↻',
  [ConnectionState.Authenticating]: '⚷',
  [ConnectionState.Failed]: '✗',
  [ConnectionState.Disconnected]: '○',
  [ConnectionState.Rejected]: '⊘',
  [ConnectionState.PendingApproval]: '⏸',
};

const stateColor = (tokens: ThemeTokens, connectionState: ConnectionState): string => {
  switch (connectionState) {
    case ConnectionState.Connected:
      return tokens.text.success;
    case ConnectionState.Connecting:
    case ConnectionState.Authenticating:
    case ConnectionState.PendingApproval:
      return tokens.text.warning;
    case ConnectionState.Failed:
    case ConnectionState.Rejected:
      return tokens.text.danger;
    case ConnectionState.Disconnected:
    default:
      return tokens.text.subtle;
  }
};

export function getConnectionStateDisplay(
  tokens: ThemeTokens,
  connectionState: ConnectionState,
): StateDisplay {
  const icon = STATE_ICONS[connectionState] ?? '?';
  return { icon, color: stateColor(tokens, connectionState) };
}
